.secondary-info {
    margin: -12px 16px 0 56px;
    padding-bottom: 12px;
    color: var(--grey);
    overflow: hidden;
    text-overflow: ellipsis;
}

.formatted-timestamp {
    font-weight: 400;
    font-size: var(--font-tiny);
    color: var(--grey-lt);
    min-width: 48px;
    text-align: right;
}

.empty-state-container {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
}
